import * as React from 'react'
import { connect } from 'react-redux'
//import { ApplicationState } from '../../store'
import {
    Row, Col, Spinner, InputGroup, Input, InputGroupButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button
} from 'reactstrap';

interface IState {
    modal: boolean
    term : string
    year : number
    searchProfession : string
    searchCountry : string
    dropdownOpenYear : boolean
    dropdownOpenProfession : boolean
    dropdownOpenCountry : boolean
}
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    term:string
    year:number
    profession:string
    country:string
    loading: boolean
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    onSearch: any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch;


class ListSearch extends React.Component<AllProps, IState> {

    /**
     *
     */
    constructor(props: AllProps) {
        super(props);
        this.state = {
            modal: false,
            term : this.props.term,
            year : this.props.year === 0 ? new Date().getFullYear() : this.props.year,
            searchProfession: this.props.profession == ''? 'All Profession' : this.props.profession,
            searchCountry: this.props.country== ''? 'All Country' : this.props.country,
            dropdownOpenYear : false,
            dropdownOpenProfession : false,
            dropdownOpenCountry: false
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.onChangeYear = this.onChangeYear.bind(this);
        this.onChangeProfession = this.onChangeProfession.bind(this);
        this.onChangeCountry = this.onChangeCountry.bind(this);
        this.onEnterPressed = this.onEnterPressed.bind(this);
    }
    public componentDidMount() {
    }
    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.term !== this.props.term){
            this.setState({term:this.props.term}); 
        }
        if (this.props.year != undefined && prevProps.year !== this.props.year){
            this.setState({year:this.props.year}); 
        }
        if (prevProps.profession !== this.props.profession){
            this.setState({searchProfession:this.props.profession}); 
        }
        if (prevProps.country !== this.props.country){
            this.setState({searchCountry:this.props.country}); 
        }
    }

    onInputChange(e:any) {
        this.setState({ term: e.target.value });
    }
    onChangeYear(e:any){
        this.setState({ year: Number(e.currentTarget.textContent) })
    }
    onChangeProfession(e:any){
        this.setState({ searchProfession: e.currentTarget.textContent})
    }
    onChangeCountry(e:any){
        this.setState({ searchCountry: e.currentTarget.getAttribute("dropdownvalue")})
    }
    onEnterPressed(e:any){
        var code = e.keyCode || e.which;
        if(code === 13) { //13 is the enter keycode
            //console.log("Entered");
            this.props.onSearch(this.state);
        } 
    }
    
    public render() {
        const toggleDropDownYear = () => this.setState({dropdownOpenYear : !this.state.dropdownOpenYear}); 
        const toggleDropDownProfession = () => this.setState({dropdownOpenProfession : !this.state.dropdownOpenProfession}); 
        const toggleDropDownCountry = () => this.setState({dropdownOpenCountry : !this.state.dropdownOpenCountry}); 
        
        const _countryList = [
            { value: 'MY', label: 'Malaysia' },
            { value: 'SG', label: 'Singapore' },
            { value: 'ID', label: 'Indonesia' },
          ];

        const getCountry = (e: any) => {
            let matchObj = _countryList.filter(function (item: any) {
                return (e == item.value);
            });
            if (matchObj && matchObj.length > 0) {
               return matchObj[0].label;
            } else {
                return "All Country";
            }
        }

        return (
            <Row>
                <Col lg="10" >
                    <InputGroup>
                        <Input placeholder="Search for anything" value={this.state.term} onChange={this.onInputChange} onKeyPress={this.onEnterPressed.bind(this)}/>
                        <InputGroupButtonDropdown addonType="append" isOpen={this.state.dropdownOpenYear} toggle={toggleDropDownYear}>
                            <DropdownToggle caret color="primary">
                                {this.state.year}
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={this.onChangeYear}>2020</DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem onClick={this.onChangeYear}>2020</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2021</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2022</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2023</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2024</DropdownItem>
                                <DropdownItem onClick={this.onChangeYear}>2025</DropdownItem>
                            </DropdownMenu>
                        </InputGroupButtonDropdown>
                        <InputGroupButtonDropdown addonType="append" isOpen={this.state.dropdownOpenProfession} toggle={toggleDropDownProfession}>
                            <DropdownToggle caret>
                                {this.state.searchProfession}
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={this.onChangeProfession}>All Profession</DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem onClick={this.onChangeProfession}>Accountancy</DropdownItem>
                                <DropdownItem onClick={this.onChangeProfession}>Company Secretary</DropdownItem>
                                <DropdownItem onClick={this.onChangeProfession}>Contractor</DropdownItem>
                                <DropdownItem onClick={this.onChangeProfession}>Engineering</DropdownItem>
                                <DropdownItem onClick={this.onChangeProfession}>Tax Agent</DropdownItem>
                                <DropdownItem onClick={this.onChangeProfession}>Project Management</DropdownItem>
                                <DropdownItem onClick={this.onChangeProfession}>MBOT</DropdownItem>
                            </DropdownMenu>
                        </InputGroupButtonDropdown>
                        <InputGroupButtonDropdown addonType="append" isOpen={this.state.dropdownOpenCountry} toggle={toggleDropDownCountry}>
                            <DropdownToggle caret color="warning">
                                {
                                    getCountry(this.state.searchCountry)
                                }
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={this.onChangeCountry} dropDownValue="All Country">All Country</DropdownItem>
                                <DropdownItem divider />
                                {
                                    _countryList.map(item =>(
                                        <DropdownItem onClick={this.onChangeCountry} dropDownValue={item.value}>{item.label}</DropdownItem>
                                    ))
                                }
                            </DropdownMenu>
                        </InputGroupButtonDropdown>
                    </InputGroup>
                </Col>
                <Col lg="2" >
                    <Button color="success" onClick={this.props.onSearch.bind(this, this.state)} block>
                        <i className="fas fa-search mr-1"></i>
                        &nbsp;&nbsp;Search&nbsp;&nbsp;</Button>
                </Col>
            </Row>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = () => ({
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps
)(ListSearch)